/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { MenuItem, styled } from '@mui/material';
import { StyleConstants } from '../../../../Shared/Constants/Style.Constants';

export const FilterOptions = styled(MenuItem)<{ selected?: boolean }>(({ theme, selected }) => ({
  borderBottom: `0.0625rem solid ${theme.palette.divider}`,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.h4.fontSize,
  fontWeight: selected ? theme.typography.fontWeightBold : theme.typography.fontWeightLight,

  lineHeight: '1.375rem',
  textWrap: 'wrap',
  letterSpacing: StyleConstants.LetterSpacingTight,
  backgroundColor: selected ? theme.palette.primary.main : 'transparent',
  '&:hover': {
    backgroundColor: theme.palette.secondary.dark,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.warning.contrastText,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.h4.fontSize,
    lineHeight: '1.375rem',
    letterSpacing: StyleConstants.LetterSpacingTight,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
    [theme.breakpoints.down('laptop')]: {
      fontSize: theme.typography.h5.fontSize,
    },
  },
  [theme.breakpoints.down('laptop')]: {
    fontSize: theme.typography.h5.fontSize,
  },
  '&:last-child': {
    borderBottom: 'none',
  },
}));
